module.exports = __webpack_public_path__ + "cc8445825435a200afc357c2e9d3fff2.pdf";